import type { PaginatedResponse } from '@reliance/types/responses/PaginatedResponse';
import { VisitationFilters } from '@reliance/types/filters/VisitationFilters';
import { Visitation } from '@reliance/types/models/Visitation';
import { useAsync } from 'react-async-hook';
import api from '../common/api';

export type VisitationTableResult = Visitation & {
  status?: string;
  facility?: { name: string; city?: string; state?: string };
};

export const useVisitations = (facilityId: number | null | undefined, filters?: Omit<VisitationFilters, 'facilityId'>) => {
  const key = JSON.stringify({ facilityId, ...filters });
  return useAsync<PaginatedResponse<VisitationTableResult> | null>(
    () => {
      if (facilityId == null) {
        return Promise.resolve(null);
      }
      return api
        .get<PaginatedResponse<VisitationTableResult>>('/visitation', {
          params: { facilityId, ...filters },
        })
        .then((r) => r.data);
    },
    [key]
  );
};
